export const ENTERPRISE_URL = "/enterprise-hub";

// The manual scenario picker and its one-URL-per-scenario routes were removed for launch —
// the landing state is derived from live data instead (resolveScenario, rendered by
// ResolvedScenario). The NewUser and PendingInvite scenario components are parked in
// src/pages/enterprise-hub/scenarios: unreachable from real data today (routing sends
// org-less users to /welcome before the hub; nothing surfaces invites).
